import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Observable, map } from 'rxjs';
import { ConditionModel } from 'src/app/models/condition.model';
import { MultiClaimCalculatorService } from 'src/app/services/multi-claim-calculator-service';

declare type GroupedConditions = { death: ConditionViewModel[], major: ConditionViewModel[], cancer: ConditionViewModel[], other: ConditionViewModel[] };

@Component({
  selector: 'app-apg-conditions',
  templateUrl: './apg-conditions.component.html',
  styleUrls: ['./apg-conditions.component.scss'],
})
export class ApgConditionsComponent implements OnInit {
  conditions$: Observable<GroupedConditions>;

  @Output() conditionAdded = new EventEmitter<{ condition: ConditionModel, selected: boolean }>();
  @Output() resetGraph = new EventEmitter();

  deathCount = 0;
  majorCount = 0;
  cancerCount = 0;
  otherCount = 0;

  constructor(
    private multiClaimCalculatorService: MultiClaimCalculatorService
  ) {

  }

  async ngOnInit() {
    this.conditions$ = this.multiClaimCalculatorService.listConditions$().pipe(
      map(x => this.mapConditions(x.map(y => toConditionViewModel(y))))
    );
  }

  mapConditions(source: ConditionViewModel[]) {
    const death = new Array<ConditionViewModel>(),
      major = new Array<ConditionViewModel>(),
      cancer = new Array<ConditionViewModel>(),
      other = new Array<ConditionViewModel>();

    for (const c of source) {
      if (c.death) {
        death.push(c);
        death.push({ ...c, relatedToPrevClaim: true, group: 'Related Death / TI / TPD', disabled: true });
      }
      else if (c.major)
        major.push(c);
      else if (c.code.includes('CANCER') || c.code.includes('CARCINOMA'))
        cancer.push(c);
      else
        other.push(c);
    }

    return { death, major, cancer, other };
  }

  async addCondition(condition: ConditionModel, conditions: GroupedConditions) {
    const deathCount = conditions.death.filter(x => x.checked).length;
    const majorCount = conditions.major.filter(x => x.checked).length;
    const cancerCount = conditions.cancer.filter(x => x.checked).length;
    const otherCount = conditions.other.filter(x => x.checked).length;

    conditions.death.forEach(x => x.disabled = (deathCount > 0 || majorCount > 2) || (x.relatedToPrevClaim && majorCount === 0));
    conditions.major.forEach(x => x.disabled = (deathCount > 0 || majorCount > 2))
    conditions.cancer.forEach(x => x.disabled = (deathCount > 0 || cancerCount > 0 || majorCount > 2));
    conditions.other.forEach(x => x.disabled = (deathCount > 0 || otherCount > 2 || majorCount > 2));

    this.conditionAdded.emit({ condition: condition, selected: condition.checked });
  }

  async reset() {
    this.conditions$ = this.multiClaimCalculatorService.listConditions$().pipe(
      map(x => this.mapConditions(x.map(toConditionViewModel)))
    );

    this.deathCount = 0;
    this.majorCount = 0;
    this.cancerCount = 0;
    this.otherCount = 0;

    this.resetGraph.emit();
  }

}

export class ConditionViewModel {
  code: string;
  condition: number;
  relatedToPrevClaim: boolean;
  checked: boolean;
  group: string;
  death: boolean;
  major: boolean;
  disabled: boolean;
}

function toConditionViewModel(src: ConditionModel): ConditionViewModel {
  return { ...src, disabled: false, checked: false };
}
